(function () {
  'use strict'

  var MODULE_NAME = 'thismoment.common.component.video'

  require('angular')
    .module(MODULE_NAME, [
      require('./video')
    ])

  module.exports = MODULE_NAME
})()



// WEBPACK FOOTER //
// ./src/common/component/video/index.js